import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import type { ImageSettings } from '@legacy/common-ui-utility-components';
import {
  getImageSettingsFromRendering,
  ImageComponent,
} from '@legacy/common-ui-utility-components';
import { InnogyComponentRendering } from '@core/jss-models';
import { ColumnContext } from '@legacy/common-ui-shared-interfaces';
import { TrackImpressionDirective } from '@analytics/events';

@Component({
  selector: 'wl-image-wrapper',
  templateUrl: './image-wrapper.component.html',
  styleUrls: [],
  standalone: true,
  imports: [ImageComponent, TrackImpressionDirective],
})
export class ImageWrapperComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() context?: ColumnContext;

  imageSettings?: ImageSettings;

  ngOnInit() {
    if (this.rendering) {
      this.imageSettings = getImageSettingsFromRendering(this.rendering);
    }
  }
}
